import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthLayout } from '@/layouts/AuthLayout';
// import { ProtectedRoute } from '@/components/common/ProtectedRoute';
import loadable from '@/utils/loadable';

import StakeModal from './components/modals/StakeModal';
import ChangePasswordModal from './components/modals/ChangePasswordModal';
import ProhibitedTerritoriesModal from './components/modals/ProhibitedTerritoriesModal';
import UnderageGamblingModal from './components/modals/UnderageGamblingModal';
import RulesModal from './components/modals/RulesModal';

// const NotFoundPage = loadable(() => import('@/pages/NotFoundPage'));
import LoginPage from '@/pages/auth/LoginPage';
import { useEffect } from 'react';
import { useAppDispatch } from './hooks';
import { logout } from './store/slices/authSlice';
import MaintenancePage from './pages/MaintenancePage';

const RaceMarketDetailsPage = loadable(() => import('@/pages/MarketDetails/race'));
const HomeLayout = loadable(() => import('@/layouts/HomeLayout'));
const FooterLayout = loadable(() => import('@/layouts/FooterLayout'));
const HomeLayoutNoSidebar = loadable(() => import('@/layouts/HomeLayoutNoSidebar'));
const Homepage = loadable(() => import('@/pages/Home'));
const SportMarketDetailsPage = loadable(() => import('@/pages/MarketDetails/sport'));

const LiveCasinoPage = loadable(() => import('./pages/casino/LiveCasino'));
const CrashPage = loadable(() => import('@/pages/casino/Crash'));
const SlotGamesPage = loadable(() => import('@/pages/casino/SlotGames'));
const FantasyGamesPage = loadable(() => import('@/pages/casino/FantasyGames'));
const LotteryGamesPage = loadable(() => import('@/pages/casino/Lottery'));

const AccountStatementPage = loadable(() => import('@/pages/reports/AccountStatementPage'));
const ActivityLogPage = loadable(() => import('@/pages/reports/ActivityLogPage'));
const CasinoResultsPage = loadable(() => import('@/pages/reports/CasinoResultsPage'));
const FraudReportPage = loadable(() => import('@/pages/reports/FraudReportPage'));
const SportBookBetsPage = loadable(() => import('@/pages/reports/SportBookBetsPage'));
const CurrentBetsPage = loadable(() => import('@/pages/reports/CurrentBetsPage'));
const SecurityAuthVerificationPage = loadable(
  () => import('@/pages/reports/SecurityAuthVerificationPage')
);
const LiveCasinoBetsPage = loadable(() => import('@/pages/reports/LiveCasinoBetsPage'));
const TermsAndConditionsPage = loadable(() => import('@/pages/TermsAndConditions'));
const ResponsibleGamingPage = loadable(() => import('@/pages/ResponsibleGaming'));
const FAQPage = loadable(() => import('@/pages/FAQ'));

export function App() {
  if (import.meta.env.VITE_MAINTENANCE_MODE === 'true') {
    return (
      <Routes>
        <Route path="*" element={<MaintenancePage />} />
      </Routes>
    );
  }

  return (
    <>
      <Routes>
        {/* Auth Routes */}
        <Route element={<AuthLayout />}>
          <Route path="/login" element={<LoginPage />} />
        </Route>

        <Route element={<HomeLayout />}>
          <Route index path="/" element={<Homepage />} />
          <Route path="/">
            <Route
              path="sport/details/:sportName/:eventId/:competitionName?"
              element={<SportMarketDetailsPage />}
            />
            <Route
              path="race/details/:countryCode/:raceVenue/:raceName/:eventId/:marketId?"
              element={<RaceMarketDetailsPage />}
            />
          </Route>
        </Route>

        <Route element={<HomeLayoutNoSidebar />}>
          <Route path="/casino">
            <Route path="live" element={<LiveCasinoPage />} />
            <Route path="crash" element={<CrashPage />} />
            <Route path="slot" element={<SlotGamesPage />} />
            <Route path="fantasy-games" element={<FantasyGamesPage />} />
            <Route path="lottery-games" element={<LotteryGamesPage />} />
          </Route>
          <Route path="/report">
            <Route path="account-statement" element={<AccountStatementPage />} />
            <Route path="activity-log" element={<ActivityLogPage />} />
            <Route path="casino-results" element={<CasinoResultsPage />} />
            <Route path="fraud-report" element={<FraudReportPage />} />
            <Route path="sportbook-bets" element={<SportBookBetsPage />} />
            <Route path="current-bets" element={<CurrentBetsPage />} />
            <Route path="security-auth-verification" element={<SecurityAuthVerificationPage />} />
            <Route path="live-casino-bets" element={<LiveCasinoBetsPage />} />
          </Route>
          <Route path="/faq" element={<FAQPage />} />
        </Route>

        <Route element={<FooterLayout />}>
          <Route path="/terms-and-conditions" element={<TermsAndConditionsPage />} />
          <Route path="/responsible-gaming" element={<ResponsibleGamingPage />} />
        </Route>

        {/* Protected Routes */}
        {/* <Route element={<ProtectedRoute />}></Route> */}

        {/* 404 */}
        {/* <Route path="*" element={<NotFoundPage />} /> */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>

      <StakeModal />
      <ChangePasswordModal />
      <ProhibitedTerritoriesModal />
      <UnderageGamblingModal />
      <RulesModal />
    </>
  );
}
